import Grid from '@mui/material/Grid';
import { useMedia } from '@/hooks/useMedia/useMedia';
import { Skeleton } from '@mui/material';

import { LessonFolder } from '@/models/lessonFolder';
import { FolderCard, FolderCardActionProp } from './FolderCard';

function FolderCardSkeleton() {
    return (
        <div data-testid='folder-card-skeleton' style={{ border: '1px solid transparent' }}>
            <Skeleton height={92} width={340} variant='rounded' />
        </div>
    );
}

type Props = {
    isSelecting?: boolean;
    selectedFolders?: LessonFolder[];
    folders?: LessonFolder[];
    loading?: number;
} & FolderCardActionProp;

export const FolderGrid = ({ folders, loading, onActionClick, onPreviewClick, isSelecting, selectedFolders, onSelected }: Props) => {
    const { isMobile } = useMedia();

    return (
        <Grid container spacing={2} sx={{ justifyContent: isMobile ? 'space-evenly' : 'flex-start' }}>
            {folders?.map((folder) => (
                <Grid key={folder.id}>
                    <FolderCard
                        folder={folder}
                        onSelected={onSelected}
                        onPreviewClick={onPreviewClick}
                        onActionClick={onActionClick}
                        isSelecting={isSelecting}
                        isSelected={selectedFolders?.some((f) => f.id === folder.id)}
                    />
                </Grid>
            ))}
            {loading &&
                loading > 0 &&
                Array.from(Array(loading)).map((_, index) => (
                    <Grid key={`folder-card-skeleton-${index}`}>
                        <FolderCardSkeleton />
                    </Grid>
                ))}
        </Grid>
    );
};
